{
  "signIn": {
    "description": "Введите данные учётной записи.",
    "username": "Логин",
    "rejected": "Неверный логин или пароль.",
    "blocked": "Учётная запись заблокирована. Обратитесь к администратору.",
    "rateLimited": "Слишком много попыток входа. Попробуйте позже.",
    "unavailable": "Сервер аутентификации недоступен.",
    "noAccount": "Нет учётной записи?",
    "register": "Зарегистрироваться"
  },
  "register": {
    "title": "Регистрация",
    "description": "Логин можно будет сменить только через администратора.",
    "username": "Логин",
    "usernameHint": "Латиница, цифры, подчёркивание",
    "password": "Пароль",
    "submit": "Создать учётную запись",
    "haveAccount": "Уже есть учётная запись?",
    "signIn": "Войти",
    "taken": "Такой логин уже занят.",
    "invalid": "Логин или пароль не подходит по правилам.",
    "closed": "Регистрация закрыта.",
    "rateLimited": "Слишком много попыток. Попробуйте позже.",
    "unavailable": "Сервер аутентификации недоступен.",
    "usernamePattern": "Только строчная латиница, цифры и подчёркивание, от 3 до 32 символов",
    "usernameReserved": "Логин зарезервирован"
  },
  "account": {
    "title": "Учётная запись",
    "description": "Пароль и активные сеансы.",
    "forcedTitle": "Смените пароль",
    "forcedDescription": "Пароль задан администратором. До смены остальные разделы недоступны.",
    "password": {
      "title": "Пароль",
      "description": "Смена пароля завершит все сеансы, кроме текущего.",
      "current": "Текущий пароль",
      "next": "Новый пароль",
      "repeat": "Новый пароль ещё раз",
      "submit": "Сменить пароль",
      "mismatch": "Пароли не совпадают",
      "wrongCurrent": "Неверный текущий пароль"
    },
    "sessions": {
      "title": "Активные сеансы",
      "description": "Каждый вход создаёт отдельный сеанс.",
      "empty": "Нет активных сеансов",
      "current": "Текущий",
      "columns": {
        "ip": "IP",
        "userAgent": "Устройство",
        "created": "Начат",
        "expires": "Истекает"
      },
      "revokeAll": "Выйти на всех устройствах",
      "revokeTitle": "Выйти на всех устройствах?",
      "revokeDescription": "Все сеансы будут завершены, включая текущий. Потребуется войти заново.",
      "revokeSubmit": "Выйти везде"
    }
  },
  "sudo": {
    "title": "Подтвердите пароль",
    "description": "Действие затрагивает учётные записи, поэтому нужен пароль.",
    "password": "Пароль",
    "submit": "Подтвердить",
    "failed": "Неверный пароль."
  }
}
